import React, { useContext } from 'react';
import Button from '@src/components/wysiwyg_editor/toolbox/Button';

import textImg from '@images/wysiwyg_editor/toolbox_icons/text.svg';
import useIsLargeScreen from '../../../../hooks/useIsLargeScreen';
import { WysiwygEditorDispatchContext } from '@src/contexts/wysiwyg/editor';

type TProps = {
  active: boolean;
};

function Text(props: TProps): React.ReactElement {
  const isLarge = useIsLargeScreen();
  const { toggleToolboxTab } = useContext(WysiwygEditorDispatchContext);

  return (
    <Button
      active={props.active}
      image={textImg as string}
      style={isLarge ? { borderTop: 'none' } : {}}
      onClick={() => toggleToolboxTab('text')}
    >
      Text
    </Button>
  );
}

export default Text;
